import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { WAREHOUSE_INTRO_SAMPLE } from "../consts";
import { WarehouseSceneProps } from "../types";

/** Korak "Adresa": karta s oznakom skladišta, adresa i koordinate. */
const WarehouseAddressScene: React.FC<WarehouseSceneProps> = ({ formValues }) => {
  const hasAddress = !!(formValues.addressLine1 || formValues.addressCity);
  const addressLine = hasAddress ? formValues.addressLine1 : WAREHOUSE_INTRO_SAMPLE.addressLine;
  const addressCity = hasAddress
    ? [formValues.addressPostalCode, formValues.addressCity, formValues.addressCountry].filter(Boolean).join(", ")
    : WAREHOUSE_INTRO_SAMPLE.addressCity;
  const latitude = formValues.addressLatitude ?? WAREHOUSE_INTRO_SAMPLE.latitude;
  const longitude = formValues.addressLongitude ?? WAREHOUSE_INTRO_SAMPLE.longitude;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          {/* Karta: mreža ulica i oznaka skladišta u sredini. */}
          <div className="relative h-[10rem] rounded-md bg-emerald-50 overflow-hidden">
            <span className="absolute inset-x-0 top-[35%] h-2 bg-white" />
            <span className="absolute inset-x-0 top-[72%] h-1.5 bg-white" />
            <span className="absolute inset-y-0 left-[30%] w-2 bg-white" />
            <span className="absolute inset-y-0 left-[70%] w-1.5 bg-white" />
            <span className="absolute left-[8%] top-[48%] w-[18%] h-[18%] rounded-sm bg-emerald-100" />
            <span className="absolute left-[76%] top-[8%] w-[18%] h-[22%] rounded-sm bg-emerald-100" />
            <span className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-full">
              <svg className="w-8 h-8 drop-shadow" viewBox="0 0 24 24" fill="#1D4ED8" aria-hidden="true">
                <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
              </svg>
            </span>
          </div>

          <div className="mt-3 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">
            {formValues.name || WAREHOUSE_INTRO_SAMPLE.name}
          </div>
          <div className="text-sm font-bold text-slate-800 truncate">{addressLine}</div>
          <div className="text-[0.65rem] text-slate-400 truncate">{addressCity}</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Koordinate</div>
          <div className="mt-2 space-y-1 text-[0.7rem]">
            <div className="flex justify-between">
              <span className="text-slate-500">Širina</span>
              <span className="font-semibold text-slate-700">{latitude.toFixed(4)}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-500">Dužina</span>
              <span className="font-semibold text-slate-700">{longitude.toFixed(4)}</span>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Lokacija je na karti"
          subtitle="Skladište se lako pronađe"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M9 20l-6-3V4l6 3 6-3 6 3v13l-6-3-6 3zM9 7v13M15 4v13" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(WarehouseAddressScene);
